/** Validación CUIT/CUIL argentino (módulo 11) */

export function normalizeCuit(value) {
  if (value == null || value === '') return '';
  return String(value).replace(/\D/g, '');
}

export function formatCuit(value) {
  const d = normalizeCuit(value);
  if (d.length !== 11) return String(value || '').trim();
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}

export function validateCuit(value, { required = false } = {}) {
  const digits = normalizeCuit(value);
  if (!digits) {
    return required
      ? { valid: false, error: 'El CUIT es obligatorio.' }
      : { valid: true, value: '', formatted: '' };
  }
  if (digits.length !== 11) {
    return { valid: false, error: 'El CUIT debe tener 11 dígitos.' };
  }

  const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 10; i += 1) sum += Number(digits[i]) * mult[i];
  const mod = 11 - (sum % 11);
  const check = mod === 11 ? 0 : mod === 10 ? 9 : mod;

  if (Number(digits[10]) !== check) {
    return { valid: false, error: 'CUIT inválido (dígito verificador incorrecto).' };
  }

  return { valid: true, value: digits, formatted: formatCuit(digits) };
}
